import { jsx as _jsx } from "react/jsx-runtime";
import { useDebouncedCallback } from 'use-debounce';
import { useLocalizeMessage, Table } from 'libs.nucleus';
import { useParticipantsTableColumns } from './participants_table_columns.hook';
import { useFetchParticipants } from '../../hooks/use_fetch_participants';
const DEFAULT_PAGE_SIZE = 10;
export const ParticipantsTable = () => {
    const translate = useLocalizeMessage();
    const { participantsColumns } = useParticipantsTableColumns();
    const { isFetching, participants, totalPages, pagination, setPagination, setSearchValue } = useFetchParticipants({
        initialPage: 0,
        initialPageSize: DEFAULT_PAGE_SIZE,
    });
    const handleSearch = useDebouncedCallback((searchValue) => {
        setSearchValue(searchValue);
    }, 500);
    return (_jsx(Table, { columns: participantsColumns, data: participants || [], onSearch: handleSearch, searchFunction: () => {
            //  Always return true to disable client side search. Handle server side search with onSearch
            return true;
        }, isLoading: isFetching, labelNoResults: translate('info.participants_table.empty'), paginationNavigationScreenReaderLabel: translate('info.participants_table.navigation'), useInternalSearch: true, labelSearchField: translate('generic.search'), hasPagination: true, manualPagination: true, initialPageSize: DEFAULT_PAGE_SIZE, pageCount: totalPages, manualPaginationState: pagination, onPaginationChange: setPagination }));
};
